<section class="carousel swiper" #swiperContainer [ngClass]="{ autoHeight: autoHeight() }">
    <div class="swiper-wrapper carousel__wrapper" #swiperContent [attr.aria-label]="mainAriaLabel()">
        @for (slide of slides(); track $index) {
            <div
                class="carousel__slide swiper-slide"
                [class.white-bg]="whiteBackground()"
                role="group"
                [attr.aria-label]="'slide ' + ($index + 1) + ' of ' + slides()?.length"
            >
                <!-- Image behaves like a background -->
                <img
                    class="carousel__image"
                    alt="{{ slide.title }}"
                    imgFallback
                    [inputSrcSet]="slide.sourceSet"
                    [style]="imageStyle()"
                />

                <!-- Overlay -->
                <div
                    class="darken-overlay"
                    [ngClass]="{ forLanding: isForLanding(), forBrandPage: isForBrandPage() }"
                ></div>

                <!-- Content Template -->
                @if (textTemplate()) {
                    <ng-container *ngTemplateOutlet="textTemplate()!"></ng-container>
                } @else {
                    <div class="carousel__slide-content">
                        @if (slide.header) {
                            <p class="carousel__slide-content-shops subheading-2">{{ slide.header }}</p>
                        }
                        <h2
                            class="carousel__slide-content-brand heading-1"
                            [innerHTML]="slide.title | superscript"
                        ></h2>

                        @if (slide.subtitle) {
                            <h2 class="carousel__slide-content-subtitle body-1">{{ slide.subtitle }}</h2>
                        }
                        @if (slide.description) {
                            <p class="carousel__slide-content-descr body-0">{{ slide.description }}</p>
                        }
                        @if (slide.actionTitle) {
                            <button
                                mat-stroked-button
                                class="carousel__slide-link mat-light-border"
                                #slideLink
                                [tabindex]="$index === activeIndex() ? 0 : -1"
                                (click)="clickShopProducts(slide)"
                            >
                                {{ slide.actionTitle }}
                            </button>
                        }
                    </div>
                }
            </div>
        }
    </div>
</section>
@if (displayPagination()) {
    <div class="carousel__pagination-container">
        @if (!!slides()?.length && !textTemplate() && displayAutoPlay()) {
            @if (isAutoplayEnabled()) {
                <mat-icon
                    class="carousel__pagination-action"
                    aria-label="Pause"
                    svgIcon="ico_pause"
                    [attr.aria-hidden]="false"
                    (libAccessibleClick)="toggleAutoPlay()"
                ></mat-icon>
            } @else {
                <mat-icon
                    class="carousel__pagination-action"
                    aria-label="Play"
                    svgIcon="ico_play"
                    [attr.aria-hidden]="false"
                    (libAccessibleClick)="toggleAutoPlay()"
                ></mat-icon>
            }
        }
        <div class="swiper-pagination carousel__pagination" #swiperPagination [ngClass]="{ black: isAppleBrand() }">
            @for (slide of slides(); track slide.id; let idx = $index) {
                <button
                    class="swiper-pagination-bullet carousel__pagination-bullet"
                    [class.swiper-pagination-bullet-active]="idx === activeIndex()"
                    tabindex="0"
                    type="button"
                    [ariaLabel]="'Slide ' + (idx + 1) + ' of ' + slides().length"
                    (click)="setSlide(idx)"
                    (keydown.enter)="setSlide(idx)"
                ></button>
            }
        </div>
    </div>
}
